(() => {
  function initNewsArchive(root) {
    const pageSize = parseInt(root.dataset.pageSize, 10) || 9;
    const tabs = Array.from(root.querySelectorAll('[data-news-tab]'));
    const items = Array.from(root.querySelectorAll('[data-news-item]'));
    const paginationRoot = root.querySelector('[data-news-pagination]');
    const paginationList = paginationRoot
      ? paginationRoot.querySelector('.news-archive__pagination-list')
      : null;
    const emptyState = root.querySelector('[data-news-empty]');
    const urlParams = new URLSearchParams(window.location.search);
    const availableCategories = new Set(tabs.map((tab) => tab.dataset.category || 'all'));

    let category = urlParams.get('category') || 'all';
    let currentPage = parseInt(urlParams.get('page'), 10) || 1;

    if (!availableCategories.has(category)) {
      category = 'all';
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        const targetCategory = tab.dataset.category || 'all';
        if (category === targetCategory) {
          return;
        }
        category = targetCategory;
        currentPage = 1;
        update();
      });
    });

    function updateUrl() {
      const params = new URLSearchParams(window.location.search);

      if (category === 'all') {
        params.delete('category');
      } else {
        params.set('category', category);
      }

      if (currentPage === 1) {
        params.delete('page');
      } else {
        params.set('page', currentPage);
      }

      const query = params.toString();
      const newUrl = `${window.location.pathname}${query ? `?${query}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }

    function updateTabs() {
      tabs.forEach((tab) => {
        const isActive = (tab.dataset.category || 'all') === category;
        tab.classList.toggle('news-archive__tab--active', isActive);
        if (isActive) {
          tab.setAttribute('aria-current', 'true');
        } else {
          tab.removeAttribute('aria-current');
        }
      });
    }

    function filterItems() {
      const filtered = items.filter((item) => {
        const tags = item.dataset.tags ? item.dataset.tags.split(',') : [];
        return category === 'all' || tags.includes(category);
      });

      const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
      if (currentPage > totalPages) {
        currentPage = totalPages;
      }

      items.forEach((item) => {
        item.hidden = true;
      });

      filtered.forEach((item, index) => {
        const start = (currentPage - 1) * pageSize;
        const end = start + pageSize;
        item.hidden = !(index >= start && index < end);
      });

      if (emptyState) {
        const hasResults = filtered.length > 0;
        emptyState.classList.toggle('news-archive__empty-message--hidden', hasResults);
      }

      updatePagination(totalPages);
    }

    function createPaginationButton(label, targetPage, options = {}) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'news-archive__pagination-button';
      button.textContent = label;

      if (options.isCurrent) {
        button.classList.add('news-archive__pagination-button--current');
        button.setAttribute('aria-current', 'page');
        button.disabled = true;
      } else if (options.isDisabled) {
        button.setAttribute('aria-disabled', 'true');
        button.disabled = true;
      } else {
        button.addEventListener('click', () => {
          currentPage = targetPage;
          update();
        });
      }

      if (options.ariaLabel) {
        button.setAttribute('aria-label', options.ariaLabel);
      }

      return button;
    }

    function updatePagination(totalPages) {
      if (!paginationRoot || !paginationList) {
        return;
      }

      paginationList.innerHTML = '';

      if (totalPages <= 1) {
        paginationRoot.hidden = true;
        return;
      }

      paginationRoot.hidden = false;

      const prevLabel = root.dataset.prevLabel || 'Previous';
      const nextLabel = root.dataset.nextLabel || 'Next';
      const pageLabelTemplate = root.dataset.pageLabelTemplate || 'Page {page}';

      const prevItem = document.createElement('li');
      prevItem.appendChild(
        createPaginationButton(prevLabel, currentPage - 1, {
          isDisabled: currentPage === 1,
          ariaLabel: prevLabel
        })
      );
      paginationList.appendChild(prevItem);

      for (let page = 1; page <= totalPages; page += 1) {
        const pageItem = document.createElement('li');
        pageItem.appendChild(
          createPaginationButton(String(page), page, {
            isCurrent: page === currentPage,
            ariaLabel: pageLabelTemplate
              .replace('%%PAGE%%', String(page))
              .replace('{page}', String(page))
          })
        );
        paginationList.appendChild(pageItem);
      }

      const nextItem = document.createElement('li');
      nextItem.appendChild(
        createPaginationButton(nextLabel, currentPage + 1, {
          isDisabled: currentPage === totalPages,
          ariaLabel: nextLabel
        })
      );
      paginationList.appendChild(nextItem);
    }

    function update() {
      updateTabs();
      filterItems();
      updateUrl();
    }

    update();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const components = document.querySelectorAll('[data-news-archive]');
    components.forEach(initNewsArchive);
  });
})();
